import { Trans } from "react-i18next";
import React from "react";
import { Table } from "reactstrap";

const falseCircle = "✗"
const trueCircle = "✓"

const TableHolder = ({ line}) => {
    return (
        <div className="mb-3 border p-2">
            <Table size="sm" striped>
                <thead>
                    <tr>
                        <th className="border-top-0"><Trans>Employee Name</Trans></th>
                        <th className="border-top-0"><Trans>Opening</Trans></th>
                        <th className="border-top-0"><Trans>Earned</Trans></th>
                        <th className="border-top-0"><Trans>Used</Trans></th>
                        <th className="border-top-0"><Trans>Cashed</Trans></th>
                        <th className="border-top-0"><Trans>Balance</Trans></th>
                    </tr>
                </thead>
                <tbody>
                        <tr key={line.id}>
                            <td>{line.employee__full_name}</td>
                            <td>{line.beginning}</td>
                            <td>{line.earned}</td>
                            <td>{line.used}</td>
                            <td>{line.cashed}</td>
                            <td>{line.balance}</td>
                        </tr>
                </tbody>
            </Table>
            {line.approved_holidays.length > 0 && (
                <div className="my-4">
                    <h6><Trans>Approved holidays</Trans></h6>
                    <Table size="sm">
                        <thead>
                            <tr>
                                <th>
                                    <Trans>Start</Trans>
                                </th>
                                <th>
                                    <Trans>End</Trans>
                                </th>
                                <th>
                                    <Trans>Type</Trans>
                                </th>
                                <th>
                                    <Trans>Reason</Trans>
                                </th>
                                <th>
                                    <Trans>Replacement</Trans>
                                </th>
                                <th>
                                    <Trans>Deductible</Trans>
                                </th>
                                <th>
                                    <Trans>Non-deductible</Trans>
                                </th>
                                <th>
                                    <Trans>Paid</Trans>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {line.approved_holidays.map((j) => (
                                <tr key={j.id}>
                                    <td>
                                        {j.starting} <Trans>{j.starting_time}</Trans>
                                    </td>
                                    <td>
                                        {j.ending} <Trans>{j.ending_time}</Trans>
                                    </td>
                                    <td>{j.type}</td>
                                    <td>{j.reason || "-"}</td>
                                    <td>{j.replacement_employee__full_name || "-"}</td>
                                    <td>
                                        {j.is_deductable ? j.total_days : falseCircle}
                                    </td>
                                    <td>
                                        {!j.is_deductable ? j.total_days : falseCircle}
                                    </td>
                                    <td>{j.paid ? trueCircle : falseCircle}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </div>
            )}
        </div>
    );
};

export default TableHolder